export const TIMES = {
  UNIQUE: 2,
  MANUAL: 8
};
